import React from 'react';

const Header = ({ duplicates, duplicateCellClass }) => (
  <div className="c-table-card__head c-table-card__head--underline">
    <div className="c-table-card__cell u-2/12">
      <div className="c-label">Customer details</div>
    </div>
    <div className="c-table-card__cell u-3/12">
      <div className="c-label">Surviving records</div>
    </div>
    {
      duplicates.map((_, idx) => (
        <div className={duplicateCellClass}>
          <div className="c-label">Record {idx + 1}</div>
        </div>
      ))
    }
  </div>
);

export default Header;
